export default __webpack_public_path__ + "static/CUARTO_POLLO_SOLO_PAPA-b825759b11e1d66a7163b5141ca4a464.jpg";